import { Z as l } from "./index-efd35e77.js";
import d, { Children as U, isValidElement as O, cloneElement as T } from "react";
import D from "react-dom";
function b() {
  return b = Object.assign ? Object.assign.bind() : function(r) {
    for (var s = 1; s < arguments.length; s++) {
      var o = arguments[s];
      for (var e in o)
        Object.prototype.hasOwnProperty.call(o, e) && (r[e] = o[e]);
    }
    return r;
  }, b.apply(this, arguments);
}
function A(r, s) {
  if (r == null)
    return {};
  var o = {}, e = Object.keys(r), n, t;
  for (t = 0; t < e.length; t++)
    n = e[t], !(s.indexOf(n) >= 0) && (o[n] = r[n]);
  return o;
}
function R(r, s) {
  return R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, n) {
    return e.__proto__ = n, e;
  }, R(r, s);
}
function L(r, s) {
  r.prototype = Object.create(s.prototype), r.prototype.constructor = r, R(r, s);
}
function w(r, s) {
  return r.classList ? !!s && r.classList.contains(s) : (" " + (r.className.baseVal || r.className) + " ").indexOf(" " + s + " ") !== -1;
}
function G(r, s) {
  r.classList ? r.classList.add(s) : w(r, s) || (typeof r.className == "string" ? r.className = r.className + " " + s : r.setAttribute("class", (r.className && r.className.baseVal || "") + " " + s));
}
function V(r, s) {
  return r.replace(new RegExp("(^|\\s)" + s + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function k(r, s) {
  r.classList ? r.classList.remove(s) : typeof r.className == "string" ? r.className = V(r.className, s) : r.setAttribute("class", V(r.className && r.className.baseVal || "", s));
}
const j = {
  disabled: !1
};
var q = process.env.NODE_ENV !== "production" ? l.oneOfType([l.number, l.shape({
  enter: l.number,
  exit: l.number,
  appear: l.number
}).isRequired]) : null, W = process.env.NODE_ENV !== "production" ? l.oneOfType([l.string, l.shape({
  enter: l.string,
  exit: l.string,
  active: l.string
}), l.shape({
  enter: l.string,
  enterDone: l.string,
  enterActive: l.string,
  exit: l.string,
  exitDone: l.string,
  exitActive: l.string
})]) : null;
const S = d.createContext(null);
var N = "unmounted", E = "exited", m = "entering", C = "entered", M = "exiting", h = /* @__PURE__ */ function(r) {
  L(s, r);
  function s(e, n) {
    var t;
    t = r.call(this, e, n) || this;
    var i = n, a = i && !i.isMounting ? e.enter : e.appear, u;
    return t.appearStatus = null, e.in ? a ? (u = E, t.appearStatus = m) : u = C : e.unmountOnExit || e.mountOnEnter ? u = N : u = E, t.state = {
      status: u
    }, t.nextCallback = null, t;
  }
  s.getDerivedStateFromProps = function(n, t) {
    var i = n.in;
    return i && t.status === N ? {
      status: E
    } : null;
  };
  var o = s.prototype;
  return o.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, o.componentDidUpdate = function(n) {
    var t = null;
    if (n !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== m && i !== C && (t = m) : (i === m || i === C) && (t = M);
    }
    this.updateStatus(!1, t);
  }, o.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, o.getTimeouts = function() {
    var n = this.props.timeout, t, i, a;
    return t = i = a = n, n != null && typeof n != "number" && (t = n.exit, i = n.enter, a = n.appear !== void 0 ? n.appear : i), {
      exit: t,
      enter: i,
      appear: a
    };
  }, o.updateStatus = function(n, t) {
    n === void 0 && (n = !1), t !== null ? (this.cancelNextCallback(), t === m ? this.performEnter(n) : this.performExit()) : this.props.unmountOnExit && this.state.status === E && this.setState({
      status: N
    });
  }, o.performEnter = function(n) {
    var t = this, i = this.props.enter, a = this.context ? this.context.isMounting : n, u = this.props.nodeRef ? [a] : [D.findDOMNode(this), a], p = u[0], c = u[1], f = this.getTimeouts(), v = a ? f.appear : f.enter;
    if (!n && !i || j.disabled) {
      this.safeSetState({
        status: C
      }, function() {
        t.props.onEntered(p);
      });
      return;
    }
    this.props.onEnter(p, c), this.safeSetState({
      status: m
    }, function() {
      t.props.onEntering(p, c), t.onTransitionEnd(v, function() {
        t.safeSetState({
          status: C
        }, function() {
          t.props.onEntered(p, c);
        });
      });
    });
  }, o.performExit = function() {
    var n = this, t = this.props.exit, i = this.getTimeouts(), a = this.props.nodeRef ? void 0 : D.findDOMNode(this);
    if (!t || j.disabled) {
      this.safeSetState({
        status: E
      }, function() {
        n.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: M
    }, function() {
      n.props.onExiting(a), n.onTransitionEnd(i.exit, function() {
        n.safeSetState({
          status: E
        }, function() {
          n.props.onExited(a);
        });
      });
    });
  }, o.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, o.safeSetState = function(n, t) {
    t = this.setNextCallback(t), this.setState(n, t);
  }, o.setNextCallback = function(n) {
    var t = this, i = !0;
    return this.nextCallback = function(a) {
      i && (i = !1, t.nextCallback = null, n(a));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, o.onTransitionEnd = function(n, t) {
    this.setNextCallback(t);
    var i = this.props.nodeRef ? this.props.nodeRef.current : D.findDOMNode(this), a = n == null && !this.props.addEndListener;
    if (!i || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], p = u[0], c = u[1];
      this.props.addEndListener(p, c);
    }
    n != null && setTimeout(this.nextCallback, n);
  }, o.render = function() {
    var n = this.state.status;
    if (n === N)
      return null;
    var t = this.props, i = t.children;
    t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;
    var a = A(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ d.createElement(S.Provider, {
        value: null
      }, typeof i == "function" ? i(n, a) : d.cloneElement(d.Children.only(i), a))
    );
  }, s;
}(d.Component);
h.contextType = S;
h.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: l.shape({
    current: typeof Element > "u" ? l.any : function(r, s, o, e, n, t) {
      var i = r[s];
      return l.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(r, s, o, e, n, t);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: l.oneOfType([l.func.isRequired, l.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: l.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: l.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: l.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: l.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: l.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: l.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(s) {
    var o = q;
    s.addEndListener || (o = o.isRequired);
    for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
      n[t - 1] = arguments[t];
    return o.apply(void 0, [s].concat(n));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: l.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: l.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: l.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: l.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: l.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: l.func
} : {};
function g() {
}
h.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: g,
  onEntering: g,
  onEntered: g,
  onExit: g,
  onExiting: g,
  onExited: g
};
h.UNMOUNTED = N;
h.EXITED = E;
h.ENTERING = m;
h.ENTERED = C;
h.EXITING = M;
const I = h;
var X = function(s, o) {
  return s && o && o.split(" ").forEach(function(e) {
    return G(s, e);
  });
}, _ = function(s, o) {
  return s && o && o.split(" ").forEach(function(e) {
    return k(s, e);
  });
}, y = /* @__PURE__ */ function(r) {
  L(s, r);
  function s() {
    for (var e, n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    return e = r.call.apply(r, [this].concat(t)) || this, e.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, e.onEnter = function(a, u) {
      var p = e.resolveArguments(a, u), c = p[0], f = p[1];
      e.removeClasses(c, "exit"), e.addClass(c, f ? "appear" : "enter", "base"), e.props.onEnter && e.props.onEnter(a, u);
    }, e.onEntering = function(a, u) {
      var p = e.resolveArguments(a, u), c = p[0], f = p[1], v = f ? "appear" : "enter";
      e.addClass(c, v, "active"), e.props.onEntering && e.props.onEntering(a, u);
    }, e.onEntered = function(a, u) {
      var p = e.resolveArguments(a, u), c = p[0], f = p[1], v = f ? "appear" : "enter";
      e.removeClasses(c, v), e.addClass(c, v, "done"), e.props.onEntered && e.props.onEntered(a, u);
    }, e.onExit = function(a) {
      var u = e.resolveArguments(a), p = u[0];
      e.removeClasses(p, "appear"), e.removeClasses(p, "enter"), e.addClass(p, "exit", "base"), e.props.onExit && e.props.onExit(a);
    }, e.onExiting = function(a) {
      var u = e.resolveArguments(a), p = u[0];
      e.addClass(p, "exit", "active"), e.props.onExiting && e.props.onExiting(a);
    }, e.onExited = function(a) {
      var u = e.resolveArguments(a), p = u[0];
      e.removeClasses(p, "exit"), e.addClass(p, "exit", "done"), e.props.onExited && e.props.onExited(a);
    }, e.resolveArguments = function(a, u) {
      return e.props.nodeRef ? [e.props.nodeRef.current, a] : [a, u];
    }, e.getClassNames = function(a) {
      var u = e.props.classNames, p = typeof u == "string", c = p && u ? u + "-" : "", f = p ? "" + c + a : u[a], v = p ? f + "-active" : u[a + "Active"], F = p ? f + "-done" : u[a + "Done"];
      return {
        baseClassName: f,
        activeClassName: v,
        doneClassName: F
      };
    }, e;
  }
  var o = s.prototype;
  return o.addClass = function(n, t, i) {
    var a = this.getClassNames(t)[i + "ClassName"], u = this.getClassNames("enter"), p = u.doneClassName;
    t === "appear" && i === "done" && p && (a += " " + p), i === "active" && n && n.scrollTop, a && (this.appliedClasses[t][i] = a, X(n, a));
  }, o.removeClasses = function(n, t) {
    var i = this.appliedClasses[t], a = i.base, u = i.active, p = i.done;
    this.appliedClasses[t] = {}, a && _(n, a), u && _(n, u), p && _(n, p);
  }, o.render = function() {
    var n = this.props;
    n.classNames;
    var t = A(n, ["classNames"]);
    return /* @__PURE__ */ d.createElement(I, b({}, t, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, s;
}(d.Component);
y.defaultProps = {
  classNames: ""
};
y.propTypes = process.env.NODE_ENV !== "production" ? b({}, I.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: W,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: l.func
}) : {};
const et = y;
function z(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function P(r, s) {
  var o = function(t) {
    return s && O(t) ? s(t) : t;
  }, e = /* @__PURE__ */ Object.create(null);
  return r && U.map(r, function(n) {
    return n;
  }).forEach(function(n) {
    e[n.key] = o(n);
  }), e;
}
function H(r, s) {
  r = r || {}, s = s || {};
  function o(c) {
    return c in s ? s[c] : r[c];
  }
  var e = /* @__PURE__ */ Object.create(null), n = [];
  for (var t in r)
    t in s ? n.length && (e[t] = n, n = []) : n.push(t);
  var i, a = {};
  for (var u in s) {
    if (e[u])
      for (i = 0; i < e[u].length; i++) {
        var p = e[u][i];
        a[e[u][i]] = o(p);
      }
    a[u] = o(u);
  }
  for (i = 0; i < n.length; i++)
    a[n[i]] = o(n[i]);
  return a;
}
function x(r, s, o) {
  return o[s] != null ? o[s] : r.props[s];
}
function Z(r, s) {
  return P(r.children, function(o) {
    return T(o, {
      onExited: s.bind(null, o),
      in: !0,
      appear: x(o, "appear", r),
      enter: x(o, "enter", r),
      exit: x(o, "exit", r)
    });
  });
}
function B(r, s, o) {
  var e = P(r.children), n = H(s, e);
  return Object.keys(n).forEach(function(t) {
    var i = n[t];
    if (O(i)) {
      var a = t in s, u = t in e, p = s[t], c = O(p) && !p.props.in;
      u && (!a || c) ? n[t] = T(i, {
        onExited: o.bind(null, i),
        in: !0,
        exit: x(i, "exit", r),
        enter: x(i, "enter", r)
      }) : !u && a && !c ? n[t] = T(i, {
        in: !1
      }) : u && a && O(p) && (n[t] = T(i, {
        onExited: o.bind(null, i),
        in: p.props.in,
        exit: x(i, "exit", r),
        enter: x(i, "enter", r)
      }));
    }
  }), n;
}
var J = Object.values || function(r) {
  return Object.keys(r).map(function(s) {
    return r[s];
  });
}, Q = {
  component: "div",
  childFactory: function(s) {
    return s;
  }
}, $ = /* @__PURE__ */ function(r) {
  L(s, r);
  function s(e, n) {
    var t;
    t = r.call(this, e, n) || this;
    var i = t.handleExited.bind(z(t));
    return t.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: i,
      firstRender: !0
    }, t;
  }
  var o = s.prototype;
  return o.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, o.componentWillUnmount = function() {
    this.mounted = !1;
  }, s.getDerivedStateFromProps = function(n, t) {
    var i = t.children, a = t.handleExited, u = t.firstRender;
    return {
      children: u ? Z(n, a) : B(n, i, a),
      firstRender: !1
    };
  }, o.handleExited = function(n, t) {
    var i = P(this.props.children);
    n.key in i || (n.props.onExited && n.props.onExited(t), this.mounted && this.setState(function(a) {
      var u = b({}, a.children);
      return delete u[n.key], {
        children: u
      };
    }));
  }, o.render = function() {
    var n = this.props, t = n.component, i = n.childFactory, a = A(n, ["component", "childFactory"]), u = this.state.contextValue, p = J(this.state.children).map(i);
    return delete a.appear, delete a.enter, delete a.exit, t === null ? /* @__PURE__ */ d.createElement(S.Provider, {
      value: u
    }, p) : /* @__PURE__ */ d.createElement(S.Provider, {
      value: u
    }, /* @__PURE__ */ d.createElement(t, a, p));
  }, s;
}(d.Component);
$.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: l.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: l.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: l.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: l.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: l.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: l.func
} : {};
$.defaultProps = Q;
const nt = $;
export {
  et as C,
  nt as T
};
